module.exports = __webpack_public_path__ + "static/media/group-328@3x.d1bb2dbb.png";